import { trpc } from '@/shared/api';

/** HOME 함께한 기업 로고 목록(어드민) — 노출 순서대로. */
export const useLandingPartnersQuery = () => trpc.landing.listPartnersAdmin.useQuery();
